__turbopack_context__.v({
  "horizontal": "index-module__6JDf8G__horizontal",
  "root": "index-module__6JDf8G__root",
  "vertical": "index-module__6JDf8G__vertical",
});
